import React, { FC } from 'react';
import { UserCycle } from '../../../common/model/dto/user-cycle/user-cycle';
import OvListTableField from '../atoms/OvListTableField';
import DateUtils from '../../../common/utils/services/date-utils';
import StringUtils from '../../../common/utils/services/string-utils';
import OvListTableButtonField from '../atoms/OvListTableButtonField';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';
import OvButton from '../atoms/OvButton';
import { useTranslation } from 'react-i18next';
import { Constants } from '../../../common/constants';

interface OvUserCyclesListRowProps {
  userCycle: UserCycle;
}

const OvUserCyclesListRow: FC<OvUserCyclesListRowProps> = ({ userCycle }) => {
  const { t } = useTranslation();

  return (
    <>
      <OvListTableField>
        {userCycle.start_day
          ? DateUtils.formatDate(
              new Date(userCycle.start_day),
              Constants.US_DATE_DISPLAY_FORMAT_WITHOUT_TIME
            )
          : '-'}
      </OvListTableField>
      <OvListTableField>
        {userCycle.end_day
          ? DateUtils.formatDate(
              new Date(userCycle.end_day),
              Constants.US_DATE_DISPLAY_FORMAT_WITHOUT_TIME
            )
          : '-'}
      </OvListTableField>
      <OvListTableField>{userCycle.cycle_length}</OvListTableField>
      <OvListTableField>
        {StringUtils.getPrettifiedBooleanValue(userCycle.is_ovulatory_cycle)}
      </OvListTableField>
      <OvListTableField>
        {userCycle.created_at
          ? DateUtils.formatDate(
              userCycle.created_at,
              Constants.US_DATE_DISPLAY_FORMAT_WITHOUT_TIME
            )
          : '-'}
      </OvListTableField>
      <OvListTableButtonField>
        <StyledOvButton>
          <NavLink to={`/user-cycles/${userCycle.id}`}>
            {t('common.actions.seeDetails')}
          </NavLink>
        </StyledOvButton>
      </OvListTableButtonField>
    </>
  );
};

export default OvUserCyclesListRow;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    padding: 0;
    margin: 0;
    background-color: ${Colours.OV_BASE};

    &:hover {
      a {
        color: ${Colours.OV_BASE};
      }
    }

    a {
      border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
      padding: 0.25rem 1rem;
      text-decoration: none;
      text-transform: none;
      font-weight: bold;
      font-size: 0.75rem;
      color: ${Colours.OV_WHITE};
    }
  }
`;
